import { Fragment, useMemo } from 'react';
import P2Regular from 'components/typography/P2Regular';
import { Box, Group, Stack, Tooltip } from '@mantine/core';
import P2Medium from 'components/typography/P2Medium';

/**
 * List of device types.
 */
export default function DeviceTypeList({
  deviceTypes,
  limit = 3,
}: {
  deviceTypes: { deviceTypeId: number; deviceTypeName: string }[];
  limit?: number;
}) {
  const some = useMemo(() => deviceTypes.slice(0, limit), [deviceTypes, limit]);
  const more = useMemo(() => deviceTypes.slice(limit), [deviceTypes, limit]);

  const hasMore = more.length > 0;

  if (deviceTypes.length === 0) {
    return null;
  }

  return (
    <Group spacing={8}>
      {some.map(({ deviceTypeId, deviceTypeName }, index) => (
        <Fragment key={deviceTypeId}>
          {index > 0 && <P2Regular color="gray.5">|</P2Regular>}
          <P2Regular color="gray.8">{deviceTypeName}</P2Regular>
        </Fragment>
      ))}
      {hasMore && (
        <Fragment>
          <P2Regular color="gray.5">|</P2Regular>
          <Tooltip
            bg="gray.2"
            withArrow
            label={
              <Stack spacing={4}>
                {more.map(({ deviceTypeId, deviceTypeName }) => (
                  <P2Regular key={deviceTypeId} color="gray.8">
                    {deviceTypeName}
                  </P2Regular>
                ))}
              </Stack>
            }
          >
            <Box>
              <P2Medium color="gray.6">ďalšie (+{more.length})</P2Medium>
            </Box>
          </Tooltip>
        </Fragment>
      )}
    </Group>
  );
}
